export default __webpack_public_path__ + "static/media/FileText.79cd261b.svg";